import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  recommendedContainerStyle: {
    borderTopLeftRadius: 6.2,
    borderTopRightRadius: 6.2,
    backgroundColor: Colors.ocean,
    paddingHorizontal: 16.6,
    paddingVertical: 4.3,
  },
  recommendedTextStyle: {
    ...Fonts.type.bold,
    fontSize: 16,
    lineHeight: 20,
    color: Colors.white,
  },
  recommendedCardStyle: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 1,
    borderColor: Colors.ocean,
    marginHorizontal: 0,
    marginTop: -0.5,
  },
  cardStyle: {
    marginHorizontal: 0,
    marginBottom: 16.5,
    ...cardShadow,
  },
  usersTextStyle: {
    fontSize: 14,
    lineHeight: 18,
    marginVertical: 5,
    marginStart: 52,
  },
  priceTextStyle: {
    fontSize: 18,
    lineHeight: 28,
  },
  nameTextStyle: {
    fontSize: 20,
    lineHeight: 28,
  },
});
